import React from 'react';
import { Text, Icon } from '../../../../../../components';

const ProgressBody = (props: any) => {
  const { moneyIcon, procedureSelectedInfo, lineIcon, clockIcon } = props;
  return (
    <>
      <Icon
        customized
        maxWidth="16.9px"
        height="15px"
        margin="0px 4.67px 0px 0px"
      >
        <img src={moneyIcon} alt="other" />
      </Icon>
      <Text color="#161D1F" fontSize="14px" lineHeight="20px" fontWeight="400">
        {procedureSelectedInfo?.amount}
      </Text>
      <Icon customized maxWidth="1px" height="13px" margin="0px 0px 0px 16px">
        <img src={lineIcon} alt="other" />
      </Icon>
      <Icon customized maxWidth="13.33px" margin="0px 5.33px 0px 17.33px">
        <img src={clockIcon} alt="other" />
      </Icon>
      <Text color="#161D1F" fontSize="14px" lineHeight="16px" fontWeight="400">
        {procedureSelectedInfo?.duration || ''}
      </Text>
    </>
  );
};

export default ProgressBody;
